// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SurveySessionValueModel } from './surveySessionValueModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SurveyFullSurveySessionValuesModel {
    'sessionValues'?: Array<SurveySessionValueModel>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SurveyFullSurveySessionValuesModel>> = [
        {
            "name":     "sessionValues",
            "baseName": "sessionValues",
            "type":     "Array<SurveySessionValueModel>"
        },
    ];

    static getAttributeTypeMap() {
        return SurveyFullSurveySessionValuesModel.attributeTypeMap;
    }
}
